
/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import axios from 'axios';
import { pathConstants } from '@/shared/pathConstants';
import { cookieUtils } from '@/shared/cookie.util';
import Vue from 'vue';

const validateTokens = function(data) {
    cookieUtils.createCookie('Bearer', data.access_token);
    cookieUtils.createCookie('Refresh', data.refresh_token);
    return axios
        .post(`${pathConstants.API}/impersonation`, data, {headers: {publicService: true}})
        .then(result => {return result.data;},
            err => {Vue.$log.error('validateAccessToken', err);}
        );
}

export const impersonateService = {
    validateTokens
};
